<div class="hscroll-wrapper" [class.has-overflow]="hasOverflow">
  <button
    irxBotonIcono
    tamano="mini"
    class="hscroll-arrow hscroll-arrow-left"
    tooltip="Desplazar a la izquierda"
    [disabled]="!canScrollLeft"
    (click)="scroll(-1)"
  >
    <mat-icon>chevron_left</mat-icon>
  </button>

  <div class="hscroll-content" #content (scroll)="onScroll()">
    <ng-content></ng-content>
  </div>

  <button
    irxBotonIcono
    tamano="mini"
    class="hscroll-arrow hscroll-arrow-right"
    tooltip="Desplazar a la derecha"
    [disabled]="!canScrollRight"
    (click)="scroll(1)"
  >
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
